import React from "react";

import { MDBCol, MDBContainer, MDBRow, MDBFooter, MDBIcon } from "mdbreact";

import "./styles.css";

const Footer = () => {
  return (
    <footer className="footer">
      <MDBFooter color="danger-color-dark" className="font-small pt-4 mt-4">
        <MDBContainer className="text-center text-md-left">
          <MDBRow>
            <MDBCol md="6">
              <label>
                <h5 className="title">
                  CEPREVI - Centro de Pesquisa e Reabilitação de Itapetininga
                </h5>
                <p>
                  Rua Josepha Zaglobynski Krapt, 932, Jardim Bela Vista <br />
                  CEP: 18207-740 <br />
                  Itapetininga - SP <br />
                  Tel.: (15) 3525-1302
                </p>
              </label>
            </MDBCol>
            <MDBCol
              md="6"
              className="d-flex justify-content-center align-items-center mb-4"
            >
              <a
                href="https://www.facebook.com/Ceprevi-Itapetininga-136554583596176/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <MDBIcon fab icon="facebook-square" className="footer-icon" />
              </a>
              <a href="#!">
                <MDBIcon fab icon="instagram" className="footer-icon" />
              </a>
              <a href="#!">
                <MDBIcon fab icon="youtube-square" className="footer-icon" />
              </a>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
        <div className="footer-copyright text-center py-3">
          <MDBContainer fluid>
            &copy; {new Date().getFullYear()} CEPREVI - Designed and developed
            by SamTech
          </MDBContainer>
        </div>
      </MDBFooter>
    </footer>
  );
};

export default Footer;
